import {IntegrationStatusNum} from 'enums';

export const getIsNotIntegrationFailedOrHasError = (status: number) => {
  return (
    status !== IntegrationStatusNum.TEST_FAILED &&
    status !== IntegrationStatusNum.ERROR &&
    status !== IntegrationStatusNum.TEST_PENDING
  );
};
